export default {

	/**
	 * Set what schools have access to reviews system
	 */
	schoolsWithReviews: [1, 4] // Americas, Turkey	

}